var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{staticClass:"quiz-navbar",attrs:{"variant":"faded","type":"light","fixed":"top","sticky":!_vm.sticky}},[_c('b-navbar-brand',{attrs:{"href":"/quiz"}},[_c('img',{staticClass:"quiz-brand d-inline-block align-top",attrs:{"src":_vm.imgLogo}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }